import React from 'react'
import { Link } from 'react-router-dom'

function TempoChanger() {
  return (
    <>
      <div class="banner-allpage-sec">
        <ul class="breadcrumb">
            <li><Link to="/face-analyser/">Home</Link></li>
            <li>Voice</li>
            <li>Tempo Changer</li>
        </ul>
        <div className="banner-content-sec text-center">
            <h1 className="first-head">Tempo Changer</h1>
            <h3 className="second-head">Make an audio file play faster or slower</h3>
            <br/>            
        </div>
    </div>
    <section style={{textAlign:"center", marginTop:-120, position:"relative"}}>        
        <div className="page-container">
            <div style={{border:"#ccc 2px dotted", borderRadius:10, background:"#fff", padding:50, width:"100%", margin:"auto"}}>
                <div className="chakra-heading" style={{fontSize:20, fontWeight:"bold"}}>Drag and drop a file that you want to edit</div>
                <p className="chakra-text">or</p>
                <button type="file" className="button orange opnoriginalResultDiv" style={{fontSize:26, borderRadius:10, padding:"15px 30px"}}>
                    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" focusable="false" className="chakra-icon css-13otjrl" aria-hidden="true" height="1em" width="1em" style={{width:30,height:30, position: "relative", top: 0}} xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M320 367.79h76c55 0 100-29.21 100-83.6s-53-81.47-96-83.6c-8.89-85.06-71-136.8-144-136.8-69 0-113.44 45.79-128 91.2-60 5.7-112 43.88-112 106.4s54 106.4 120 106.4h56"></path><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M320 255.79l-64-64-64 64m64 192.42V207.79"></path></svg>
                    Browse computer
                </button>
                <div className="txt-eg">Supported file formats: MP3, WAV, FLAC, OGG. Max file size 50MB.</div>
            </div>
        </div>
    </section>
    </>
  )
}

export default TempoChanger
